/**
 * element 消息提示 方法
 */
const DEFAULT_SUCCESS_TITLE = "成功";
const DEFAULT_SUCCESS_MSG = "操作成功";
const DEFAULT_ERROR_TITLE = "失败";
const DEFAULT_ERROR_MSG = "操作失败";
const DEFAULT_WARNING_TITLE = "警告";
const DEFAULT_WARNING_MSG = "当前操作异常";
const DEFAULT_INFO_TITLE = "提示";
const DEFAULT_INFO_MSG = "已经执行当前操作";

/**
 * @description notify-成功提示
 * @param {*} that this
 * @param {String} msg 提示内容
 * @param {String} title 提示标题
 */
export const successNotify = (that, msg, title) => {
  let t = title ? title : DEFAULT_SUCCESS_TITLE;
  let m = msg ? msg : DEFAULT_SUCCESS_MSG;
  that.$notify({
    title: t,
    message: m,
    type: "success",
  });
};

/**
 * @description message-成功提示
 * @param {*} that this
 * @param {String} msg 提示内容
 */
export const successMsg = (that, msg) => {
  let m = msg ? msg : DEFAULT_SUCCESS_MSG;
  that.$message({
    message: m,
    type: "success",
    showClose: false,
  });
};

/**
 * @description notify-失败提示
 * @param {*} that this
 * @param {String} msg 提示内容
 * @param {String} title 提示标题
 */
export const errorNotify = (that, msg, title) => {
  let t = title ? title : DEFAULT_ERROR_TITLE;
  let m = msg ? msg : DEFAULT_ERROR_MSG;
  that.$notify.error({
    title: t,
    message: m,
  });
};

/**
 * @description message-失败提示
 * @param {*} that this
 * @param {String} msg 提示内容
 */
export const errorMsg = (that, msg) => {
  let m = msg ? msg : DEFAULT_ERROR_MSG;
  that.$message({
    message: m,
    type: "error",
    showClose: false,
  });
};

/**
 * @description notify-消息提示
 * @param {*} that this
 * @param {String} msg 提示内容
 * @param {String} title 提示标题
 */
export const infoNotify = (that, msg, title) => {
  let t = title ? title : DEFAULT_INFO_TITLE;
  let m = msg ? msg : DEFAULT_INFO_MSG;
  that.$notify.info({
    title: t,
    message: m,
  });
};

/**
 * @description message-消息提示
 * @param {*} that this
 * @param {String} msg 提示内容
 */
export const infoMsg = (that, msg) => {
  let m = msg ? msg : DEFAULT_INFO_MSG;
  that.$message({
    message: m,
    showClose: false,
  });
};

/**
 * @description notify-警告提示
 * @param {*} that this
 * @param {String} msg 提示内容
 * @param {String} title 提示标题
 */
export const warningNotify = (that, msg, title) => {
  let t = title ? title : DEFAULT_WARNING_TITLE;
  let m = msg ? msg : DEFAULT_WARNING_MSG;
  that.$notify({
    title: t,
    message: m,
    type: "warning",
  });
};

/**
 * @description message-警告提示
 * @param {*} that this
 * @param {String} msg 提示内容
 */
export const warningMsg = (that, msg) => {
  let m = msg ? msg : DEFAULT_WARNING_MSG;
  that.$message({
    message: m,
    type: "warning",
    showClose: false,
  });
};

/**
 * @description confirm-无操作提示弹窗
 * @param {*} that this
 * @param {String} msg 提示内容
 * @param {String} title 提示标题
 */
export const confirmWory = (that, msg, title) => {
  let t = title ? title : DEFAULT_INFO_TITLE;
  let m = msg ? msg : DEFAULT_INFO_MSG;
  that.$confirm(m, t, {
    type: "warning",
    closeOnClickModal: false,
    closeOnPressEscape: false,
    showCancelButton: false
  });
}
